import { PORTFOLIO_RELIDTYPE} from '../constants';

export const getRelationPfIndex = (pfId, portfolios) => {
  const id = pfId.replace(".", "-");
  const relationPfIndex = portfolios.findIndex(pf => pf.id === id);
  return relationPfIndex
}

export const getRelationBpIndex = (bpId, portfolios) => {
  const relationBpIndex = portfolios.findIndex(pf => pf.relIdType === PORTFOLIO_RELIDTYPE.BP && bpId === pf.id);
  return relationBpIndex;
}